import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL, authFetch } from "../utils/auth";
import ToolSidebar from "../utils/ToolSideBar";
import "../../css/offers/OfferWorkspace.css";

export default function OfferReviewPage() {
  const [offers, setOffers] = useState([]);
  const [status, setStatus] = useState("awaiting_internal_approval");
  const [selected, setSelected] = useState(null);
  const [draftItems, setDraftItems] = useState([]);
  const [note, setNote] = useState("");
  const [message, setMessage] = useState("");

  const load = useCallback(async () => {
    const res = await authFetch(`${API_URL}/offers/review/?status=${status}`);
    const data = await res.json();
    setOffers(res.ok ? data.results || [] : []);
  }, [status]);

  useEffect(() => { load(); }, [load]);

  function openOffer(offer) {
    setSelected(offer);
    setDraftItems((offer.items || []).filter((item) => item.requires_quote).map((item) => ({ id: item.id, unit_price: item.quote_resolved ? item.unit_price : "", extra_days: item.quote_resolved ? item.extra_days : "", client_facing_description: item.client_facing_description || item.description || "", staff_internal_note: "" })));
    setNote(offer.partner_change_request_note || "");
    setMessage("");
  }

  function updateItem(id, field, value) {
    setDraftItems((items) => items.map((item) => item.id === id ? { ...item, [field]: value } : item));
  }

  async function review(approve) {
    if (!selected) return;
    const res = await authFetch(`${API_URL}/offers/${selected.id}/review/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ approve, changes_requested_note: approve ? "" : note, internal_note: note, items: draftItems }),
    });
    const data = await res.json();
    if (!res.ok) {
      setMessage(data.detail || "Unable to review offer.");
      return;
    }
    setSelected(data);
    setMessage(approve ? "Offer approved for sending." : "Changes requested.");
    load();
  }

  return (
    <div className="staff-shell">
      <ToolSidebar active="offers-review" />
      <main className="staff-page offer-review-page">
        <header className="conversation-header-bar">
          <div><span>Offer Review</span><h1>Custom Quote Reviews</h1><p>Price quote-required items before partners send offers to clients.</p></div>
          <select value={status} onChange={(e) => setStatus(e.target.value)}>
            <option value="awaiting_internal_approval">Awaiting review</option>
            <option value="changes_requested">Changes requested</option>
            <option value="approved_to_send">Approved</option>
          </select>
        </header>
        <div className="message-sales-layout">
          <section className="conversation-list">
            {offers.map((offer) => (
              <button type="button" className="conversation-card offer-review-row" key={offer.id} onClick={() => openOffer(offer)}>
                <div className="conversation-card-top"><div><h3>Offer v{offer.revision_number}</h3><span>{offer.status_label}</span></div><strong>${Number(offer.total_amount || 0).toFixed(2)}</strong></div>
                <p>{offer.base_plan?.name || "Custom offer"}</p>
                <small>Project #{offer.project_id}</small>
              </button>
            ))}
            {!offers.length && <section className="staff-card"><p>No offers match this filter.</p></section>}
          </section>
          <aside className="offer-workspace-panel">
            {selected ? <section className="offer-panel-section">
              <h2>Review Offer v{selected.revision_number}</h2>
              {(draftItems || []).map((item) => (
                <div className="review-quote-item" key={item.id}>
                  <label>Approved price<input value={item.unit_price} onChange={(e) => updateItem(item.id, "unit_price", e.target.value)} placeholder="0.00" /></label>
                  <label>Extra days<input value={item.extra_days} onChange={(e) => updateItem(item.id, "extra_days", e.target.value)} placeholder="0.0" /></label>
                  <label>Client-facing description<textarea value={item.client_facing_description} onChange={(e) => updateItem(item.id, "client_facing_description", e.target.value)} /></label>
                  <label>Internal note<textarea value={item.staff_internal_note} onChange={(e) => updateItem(item.id, "staff_internal_note", e.target.value)} /></label>
                </div>
              ))}
              <label>Review note<textarea value={note} onChange={(e) => setNote(e.target.value)} placeholder="Internal note or requested changes" /></label>
              <button className="primary" onClick={() => review(true)}>Approve to Send</button>
              <button onClick={() => review(false)}>Request Changes</button>
              {message && <p>{message}</p>}
              <Link to={`/offers/${selected.id}`}>Open full offer</Link>
            </section> : <section className="offer-panel-section"><p>Select an offer to review.</p></section>}
          </aside>
        </div>
      </main>
    </div>
  );
}
